import axios from "axios";

const API_URL = "/api";
// Dev ke liye: const API_URL = "http://localhost:5000/api";

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 60000, // <-- UPLOAD KE LIYE 1 MIN
  headers: {
    "Content-Type": "application/json",
  },
});

// Token har request me add ho jaye
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // <-- YE ADD KAR DO: FormData ho to Content-Type delete kar do
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"]; // browser khud boundary set karega
  }

  return config;
});

// ============== VOLUNTEER API ==============
export const registerVolunteer = (formData) => {
  return apiClient.post("/volunteer/register", formData);
  // headers yahan mat do, interceptor khud handle kar lega
};

// ============== EXPORT DEFAULT ==============
export default apiClient;